import { render, staticRenderFns } from "./MeusTemplates.vue?vue&type=template&id=524b0d1a&"
import script from "./MeusTemplates.vue?vue&type=script&lang=js&"
export * from "./MeusTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports